import React, { FC } from 'react';
import { TypeBadge, TypeBadgeCtaFields } from '@/core/generated-types';
import { Badge, Image, UniversalCta } from '@/components';

const BadgeCta: FC<TypeBadgeCtaFields> = ({
  title,
  subtitle,
  badgeText,
  textCta,
  btnCta,
  media,
  buttonSubtitle,
  backgroundColor,
}) => {
  const badgeProps = {
    fields: { badgeColor: 'Purple', text: badgeText },
  } as TypeBadge;

  return (
    <div
      className={`bg-${backgroundColor?.fields?.color} relative flex flex-col items-center px-8`}
      data-testid="badge-cta"
    >
      {media && (
        <Image
          alt={media?.fields.altText}
          imageData={media}
          className="relative top-[80px] z-10 h-[190px] w-[400px] object-contain"
        />
      )}
      <div className="relative flex max-w-[825px] flex-col items-center rounded bg-white px-8 pb-8 pt-12 text-center md:px-[60px]">
        {badgeText && <Badge {...badgeProps.fields}></Badge>}
        <div className="mb-4 mt-4 text-xl font-semibold md:text-2xl">
          {title}
        </div>
        <div className="text-base md:text-lg">{subtitle}</div>
        {textCta && (
          <UniversalCta
            link={textCta}
            className="mt-8"
            defaultButtonStyle="Link"
          />
        )}
      </div>
      {btnCta && (
        <UniversalCta
          link={btnCta}
          className="btn-responsive btn-primary btn mx-auto mt-8 w-full self-stretch md:w-auto md:self-center"
        />
      )}
      {buttonSubtitle && (
        <div className="mt-4 text-base md:text-lg">{buttonSubtitle}</div>
      )}
    </div>
  );
};

export default React.memo(BadgeCta);
